export default async ({ store, route }) => {
  const text = route.meta.reduce((theme, meta) => meta.logoText || theme, 'logoText');
  const icon = route.meta.reduce((theme, meta) => meta.logoIcon || theme, 'logoIcon');
  const theme = route.meta.reduce((theme, meta) => meta.theme || theme, 'light');

  store.commit('SET_LOGO', { text, icon });
  store.commit('SET_THEME', theme);
};
